
import CardLayout from "../Layout/CardLayout";
import React from "react";
import InversionTable from "./InversionTable";

const InversionEstrategico = (ciemId) => {

    const contributionForm =
        <InversionTable optionName={"inversionEstrategicoTable"}
                  ciemId={ciemId}
        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionEstrategicoTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};
export default InversionEstrategico;